import { stepsFullPath } from "../stepsPath";
import { TherapistFields } from "../util";

export const step8Path = "/8";
export const step8FullPath = `${stepsFullPath}${step8Path}`;
export const step8Caption = "Personal Statement";
export const coveredFields: TherapistFields = [
  "personal_statement_short_description",
];
